import React,{ useState, useEffect} from 'react';
import ScrollToTopBtn from './components/Button/ScrollToTopBtn.js';
import styled from 'styled-components';
// import Home from './Jasper/landing-page-demo.js';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import UncontrolledExample from './components/Carousel/carousel.js'; 



const OutcomeOverview = styled.div`
	width: 100%;
	height: auto;
	min-height: 100vh;
	background-color: #000;
	color: var(--color-white);
	// padding: 0 5rem;
	:nth-child(2n+1) {
		background-color: #111;
	}
	:nth-child(2n+1) h3,
	:nth-child(2n+1) .description h1,
	:nth-child(2n+1) .description p {
		color: #fff;
	}
	:nth-child(2n+1) .description .tag {
		background-color: #fff;
		color: var(--color-text);
    }
    .description {
    	display: flex;
    	flex-direction: column;
    	justify-content: center;
    	padding: 2rem;
    }
    .description.onleft {
    	padding-right: 2rem;
    	padding-left: 0;
    }
    .description h1 {
    	font-size: 24px;
    	font-weight: 300;
    	color: var(--color-text);
    }
    .description p .emoji {
    	font-size: 160%;
    	vertical-align:middle;
    }
    .description p {
    	margin-top: 0;
    	font-size: 110%;
		color: #eee;
    }
    .description strong {
    	color: #2B90FF;
    	font-weight: bold;
    }
    .description .tag {
    	font-size: 14px;
	    letter-spacing: .5px;
	    margin: 10px 0;
    }
    .image {

		display: flex;
	    align-items: center;
	    justify-content: center;
	    position: relative;
	    box-sizing: border-box;
	}
	.image::before {
	    content: '';
	    display: block;
	    padding-top: 60%;
	}
	.image img {
    	position: absolute;
		height: 100%;
	}
	.image video {
    	position: absolute;
		height: 100%;
	}
	.image img.widthfixed {
		width: 100%;
		height: auto;
		border: 8px solid #111;
		border-radius: 4px;
	}
	.image video.widthfixed {
		width: 100%;
		height: auto;
		border: 8px solid #111;
		border-radius: 4px;
	}
	h4 {
		margin: 0;
	}
`;
const DesignGoal = styled.div`
	<!-- display: flex; -->
	flex-direction: column;
	align-items: start;
	padding: 0 10px 0 0;
	height: 100%;
	>* {
		margin: 0 auto;
	}
	>img {
		display: inline-block;
		position: relative;
		width: 100%;
		height: auto;
	}
	>img:before {
		position: absolute:
		display: block;
		width: 20px;
		height: 20px;
		border-radius: 30px;
		
	}
	>div:last-child {
    padding-right: 0;
    margin-right: 0;
    background-color: red;
  }
	>h1 {
		width: 100%;
		margin: 0;
		color: #0079FF;
		font-size: 4.5em;
		margin-bottom: 10px;
		<!-- text-align: center; -->
	}
	>h3 {
		margin: 20px 0;
		font-weight: 600;
	}
	>p {
		padding-right: 10px;
		margin-bottom: 40px;
	}
`
function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { return images[item.replace('./', '')] = r(item); });
  return images;
}

const images = importAll(require.context('./assets/img/fanduel2/', false, /\.(png|jpe?g|svg|gif)$/));

const controls = [
		{ 
	    	src: images['token-1.png'],
	    	class: ''
		},
		{ 
	    	src: images['token-2.png'],
	    	class: ''
		}
];
const Wyndham = (props) => {
	useEffect(()=>{
		const faders = document.querySelectorAll(".section-box");

		const appearOptions = {
			threshold: 0,
			rootMargin: "0px 0px -150px 0px"
		};

		const appearOnScroll = new IntersectionObserver(function(
			entries,
			appearOnScroll
		) {
			entries.forEach(entry => {

				if (!entry.isIntersecting) {
					return;
				} else {
					entry.target.classList.add("appear");
					entry.target.classList.add("animate__animated");
					entry.target.classList.add("animate__fadeInUp");
					appearOnScroll.unobserve(entry.target);
				}
			});
		},
		appearOptions);

		faders.forEach(fader => {
			appearOnScroll.observe(fader);
		});



	},[])
	

		return (
		<div className="flex fanduel" style={{position: "relative", top: "80px"}}>
			<portfolio-intro className="flex">
				
				<div className="hero-img-box">
					<img src={images['cover3.png']} style={{backgroundColor: '#222', height:"auto", width:"100%"}} alt="" />
				</div>
				
			</portfolio-intro>

			<div className="portfolio-content flex-width-70">
				<h1>Automating Design-to-Dev Theming Workflows</h1>
				<div className="section-box brief">
					<div className="grid grid-gap-xs">
						<div className="col-xl-4 col-md-4 col-xs-6 col-6">
							<h4>My Role</h4>
							<ul>
								<li>Product Designer</li>
								<li>UX Engineer</li>
							</ul>
						</div>
						<div className="col-xl-4 col-md-4 col-xs-6 col-6">
							<h4>Duration</h4>
							<ul>
								<li>One week in July 2025</li>
							</ul>
							
						</div>
						
						
						<div className="col-xl-4 col-md-4 col-xs-6 col-6">
							<h4>Tools</h4>
							<ul>
								<li>Cursor</li>
								<li>Figma API, and MCP Service</li>
							</ul>
							
						</div>
					</div>	
				</div>
				
				<div className="section-box">
					<h3 className="section-title">The background</h3>
					{/*Plugin Development for Automated Component Upgrade */}	
					<p>With the rise of AI-powered design, I explored ways to automate parts of the design process to reduce manual effort and improve design-to-engineering alignment. To address the inefficiency of manually creating token spec docs and the confusion engineers face when mapping design tokens to code, I developed a Figma plugin in one week using Cursor, the Figma API, and MCP service. The plugin exports design tokens and generates visual spec documents following the W3C Design Tokens format, streamlining the handoff workflow.</p>

					<p>Here is a overview of what the plugin can do:</p>
					
					<img className="widthfixed" style={{"width": "100%",
    "border-radius": "4px"}} src={images['tokenplugin.gif']} alt="" />
    			<p>This not only saves designers hours of manual documentation work but also reduces errors and accelerates implementation for engineers, enabling teams to ship consistent, token-driven UI faster and with greater confidence.</p>
				</div>

			</div>


				{/*	<div className="section-box fullscreen-container flex flex-center">
							<OutcomeOverview className="grid" style={{"min-height": "100vh"}}>
								<div className="col-1">
								</div>
								<div className="description onleft col-xl-3 col-md-3 col-xs-12 col-12">
									<h1> Component Updates with One Click</h1>
									<p>Instantly upgrade outdated components to new, flexible versions with a single click. The plugin applies the correct variants, preserves overrides, and gives you control over the update scope.</p>
								</div>
								<div className="image col-xl-7 col-md-7 col-xs-12 col-12">
									<img className="widthfixed" src={images['plugin.gif']} alt="" />
								</div>
									
							</OutcomeOverview>
				</div>	
			*/}				

<div className="portfolio-content flex-width-70">
				<div className="section-box">
					<h3 className="section-title">The Impact</h3>
					<p>The plugin streamlined the token documentation workflow, improved design-to-dev alignment, and reduced errors in implementation.</p>
					<div className="grid">
					{
		              [{ 
		                  title: "",
		                  number: "100*9",
		                  description: "hrs saved by automating token handoff."
		              },
		              { 
		                  title: "",
		                  number: "100%",
		                  description: "accuracy and alignment through automated exports."
		              },
		              { 
		                  title: "",
		                  number: "600+",
		                  description: "tokens documented and visualized."
		              }
		            ].map((item,i) => (
		              <DesignGoal key = {i} className="col-xl-4 col-md-4 col-xs-4 col-12">
											<h3>{item.title}</h3>
											<h1>{item.number}</h1>
											<p>{item.description}</p>
		              </DesignGoal>
		            ))}
		          
					</div>
					
				</div>

				<div className="section-box">
					<h3 className="section-title">The Problem</h3>

					<p>Token handoff between design and development in product teams was slow, inconsistent, and manual. Designers documented tokens by copying values into specs, while engineers had to restructure them for code. This led to wasted time, miscommunication, and inconsistent outputs across teams.</p>
					
					<img className="widthfixed" style={{"width": "100%",
    "border-radius": "4px"}} src={images['problem.png']} alt="" />
    			</div>

				<div className="section-box">
					<h3 className="section-title">The Solution</h3>

					<p>With the fully customized Figma plugin that automated token exports in W3C-compliant JSON files, supported multiple themes and modes, visualized full token chains, and added side-by-side visuals. This eliminated manual work, reduced errors, and created a single, consistent workflow that both designers and engineers could rely on.</p>
					
    			</div>
				<div className="section-box"></div>
				

				





			


			</div>

	{/*		<div className="section-box fullscreen-container flex flex-center">

				<OutcomeOverview className="grid" style={{"min-height": "100vh"}}>
					<div className="col-1">
					</div>
				
					<div className="image col-xl-7 col-md-7 col-xs-12 col-12">
						<p>Automation is critical for scaling design system adoption in large organizations.
						Identifying and addressing pain points within the workflow can lead to impactful solutions that save time and increase consistency.
						Collaboration with cross-functional teams (developers, QA, and PMs) ensures the plugin aligns with both design and development needs.
						This project highlights my ability to not only identify systemic issues but also deliver innovative tools that drive efficiency and consistency at scale.</p>
					</div>
				</OutcomeOverview>

			</div>

		*/}	
{/*----------------------------------- The Solution -----------------------------------*/}	

			<div className="section-box fullscreen-container flex flex-center">

				

				

		

				<OutcomeOverview className="grid" style={{"min-height": "100vh"}}>
					<div className="col-1">
					</div>
					<div className="description col-xl-4 col-md-4 col-xs-12 col-12">
						<h1>Make Documentation Deliver True Value</h1>
						<p>I automated the plugin to surface full token chains and added visuals to show token types. Now teams can get the information they need in seconds, instantly see light vs. dark mode differences, and rely on documentation for clarity, speed, and alignment.</p>
					</div>
					<div className="image col-xl-6 col-md-6 col-xs-12 col-12">
						<img className="widthfixed" src={images['tokenchain.png']} alt="" />
					</div>
					<div className="col-1"></div>
					<div className="col-1"></div>
					<div className="image col-xl-5 col-md-5 col-xs-12 col-12">
						<img className="widthfixed" src={images['tokenspec1.png']} alt="" />
					</div>
					<div className="image col-xl-5 col-md-5 col-xs-12 col-12">
						<img className="widthfixed" src={images['tokenspec2.png']} alt="" />
					</div>
						
				</OutcomeOverview>

				<OutcomeOverview className="grid">
					<div className="col-1">

					</div>
					
					<div className="description col-xl-3 col-md-3 col-xs-12 col-12">
						<h1>Automated token spec generation</h1>
		
						<p>It reads values from the variable collection and displays a tree structure of all token categories. Users can select any category to generate token specs. It supports unlimited modes and generates tokens in a multi-column layout (one per mode).</p>
					</div>
					<div className="image col-xl-7 col-md-7 col-xs-12 col-12">
						<img className="widthfixed" src={images['3modes.png']} alt="" />
					</div>
					<div className="col-1">
					</div>
				</OutcomeOverview>
				
				<OutcomeOverview className="grid">
					<div className="col-1"></div>
					<div className="description col-xl-3 col-md-3 col-xs-12 col-12">
						<h1>Smart Token Spec Updates</h1>
						<p>it manages tokens smartly—detecting changes and automatically creating, updating, or removing tokens while preserving position overrides, eliminating manual errors.</p>

					</div>
					<div className="image col-xl-7 col-md-7 col-xs-12 col-12">
						<img className="widthfixed" src={images['tokenupdate.gif']} alt=""  style={{"border": "0px"}} />
					</div>
					
				</OutcomeOverview>

				<OutcomeOverview className="grid">
					<div className="col-1">

					</div>
					
					<div className="description col-xl-3 col-md-3 col-xs-12 col-12">
						<h1>Self-Contained Theme Exports</h1>
		
						<p>Exports W3C-compliant JSON files per mode (Light, Dark, custom). Each theme is self-contained and easy to swap at runtime and compatible with iOS/Android pipelines.</p>
					</div>
					<div className="image col-xl-7 col-md-7 col-xs-12 col-12">
						<img className="widthfixed" src={images['code.png']} alt="" />
					</div>
					<div className="col-1">
					</div>
				</OutcomeOverview>

				<OutcomeOverview className="grid">
					<div className="col-1"></div>
					<div className="description col-xl-3 col-md-3 col-xs-12 col-12">
						<h1>Ensuring W3C-Compliant Token Exports</h1>
						<p>Partnered with engineers to align token exports to the W3C standard—automating JSON outputs across iOS, Android, and web, and eliminating manual rework.</p>

					</div>
					<div className="image col-xl-7 col-md-7 col-xs-12 col-12">
						<img className="widthfixed" src={images['tokenexample.png']} alt="" />
					</div>
					

				</OutcomeOverview>

				<OutcomeOverview className="grid" style={{"min-height": "100vh"}}>
					<div className="col-1">
					</div>
					<div className="description col-xl-4 col-md-4 col-xs-12 col-12">
						<h1> Thanks for reading</h1>
						<p>If you're interested in how I implemented the code behind the plugin, feel free to reach out—I'd be happy to share more.</p>
					</div>
					<div className="image col-xl-6 col-md-6 col-xs-12 col-12">
						<img className="widthfixed" src={images['coding.png']} alt="" />
					</div>
						
				</OutcomeOverview>


				




			</div>





			{/*----------------------------------- The Solution -----------------------------------*/}	
			

			

			







			
			



			<ScrollToTopBtn></ScrollToTopBtn>
		</div>
		)
	
}
export default Wyndham;